import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/Input'
import ListRow from 'components/ListRow'
import { removeNonPrintableCharactersStringUtil } from 'utils/string'
import { USER_MODEL_KEY, USER_MODEL_PLACEHOLDER, USER_MODEL_REGEX } from 'models/daos/user/constants'

class UserRowName extends React.Component {
  static defaultProps = {
    isEditing: null,
    colorType: null,
    onChange: null
  }

  static propTypes = {
    value: PropTypes.string.isRequired,
    isEditing: PropTypes.bool,
    /**
     * Color type used to define a color.
     * e.g. `success` => `green`
     * @type {string}
     */
    colorType: PropTypes.oneOf(Object.values(Input.COLOR_TYPE)),
    onChange: PropTypes.func
  }

  handleChange (event, key, value) {
    this.props.onChange(value)
  }

  shouldPreventDefault (key) {
    let char = String.fromCharCode(key)
    char = removeNonPrintableCharactersStringUtil(char)
    const shouldPreventDefault = (
      // Prevent invalid characters
      (char && !USER_MODEL_REGEX[USER_MODEL_KEY.NAME].test(char))
    )
    return shouldPreventDefault
  }

  renderBody () {
    if (!this.props.isEditing) {
      return this.renderName()
    }
    return this.renderEditName()
  }

  renderEditName () {
    const props = {
      value: this.props.value,
      name: USER_MODEL_KEY.NAME,
      // Add the @ in the  :before
      before: Input.BEFORE.AT,
      placeholder: USER_MODEL_PLACEHOLDER[USER_MODEL_KEY.NAME],
      isBorderless: true,
      hasNoPadding: true,
      colorType: this.props.colorType,
      onChange: this.handleChange.bind(this),
      shouldPreventDefault: this.shouldPreventDefault.bind(this)
    }
    return <Input {...props} />
  }

  renderName () {
    return (
      <ListRow.Text>
        <span>@{this.props.value}</span>
      </ListRow.Text>
    )
  }

  render () {
    return (
      <div>
        {this.renderBody()}
      </div>
    )
  }
}

export default UserRowName
